import type { CONSORS_ADD_NOTE_STATUS } from 'cpool-constants';
import { CONSORS_ADD_NOTE_STATUSES } from 'cpool-constants';
import { schemaConsorsNote, type SchemaConsorsNote } from 'cpool-schemas';
import { sleep } from 'cpool-utils';
import { type TFunction } from 'i18next';
import { toast } from 'react-toastify';

import { API_EXTERNAL } from '~/config';
import { fetcher } from '~/queryUtils/useQuery';

export const verifyConsorsAddedNoteStatus = async ({
    loanRequestId,
    noteId,
    position,
    subscriptionIdentifier,
    t,
    waitTime = API_EXTERNAL.CONSORS.ADD_NOTE.RETRY_INTERVAL,
}: {
    loanRequestId: string;
    waitTime?: number;
    position?: number;
    noteId: string;
    t: TFunction<'de' | 'en', undefined>;
    subscriptionIdentifier: string;
}) => {
    try {
        let consorsAddNoteStatus: CONSORS_ADD_NOTE_STATUS = CONSORS_ADD_NOTE_STATUSES.PENDING;
        let counter = 0;
        let response: SchemaConsorsNote | null = null;
        while (
            consorsAddNoteStatus === CONSORS_ADD_NOTE_STATUSES.PENDING &&
            counter < API_EXTERNAL.CONSORS.ADD_NOTE.MAX_RETRIES
        ) {
            // eslint-disable-next-line no-await-in-loop
            await sleep(waitTime);
            // eslint-disable-next-line no-await-in-loop
            response = await fetcher({
                meta: {
                    queryUrl: `/query/loan-request/getConsorsNoteStatus?id=${loanRequestId}&noteId=${noteId}&subscriptionIdentifier=${subscriptionIdentifier}&position=${position}`,
                    schema: schemaConsorsNote.nullish(),
                },
            });

            if (!response) {
                toast.error(t('CONSORS_NOTES.TOASTS.ADD_NOTE_FAILED'));
                return;
            }
            consorsAddNoteStatus = response.status;
            counter += 1;
        }
        if (consorsAddNoteStatus === CONSORS_ADD_NOTE_STATUSES.PENDING) {
            toast.error(t('CONSORS_NOTES.TOASTS.ADD_NOTE_REQUEST_TIMEOUT'));
            return;
        }
        if (consorsAddNoteStatus === CONSORS_ADD_NOTE_STATUSES.ERROR || consorsAddNoteStatus === null) {
            toast.error(
                <>
                    <div>{t('CONSORS_NOTES.TOASTS.ADD_NOTE_FAILED')}</div>
                    <div>{`${t('CONSORS_NOTES.TOASTS.FAILURE_REASON')}: ${t(
                        // @ts-expect-error - TS cannot regognize this
                        `CONSORS_NOTES.TOASTS.FAILURE_REASONS.${response?.failureReason}`,
                    )}`}</div>
                </>,
            );
            return;
        }
        // at this point we know that the status is SUCCESS
        toast.success(t('CONSORS_NOTES.TOASTS.ADD_NOTE_SUCCESS'));
    } catch {
        toast.error(t('CONSORS_NOTES.TOASTS.ADD_NOTE_FAILED'));
    }
};
